import { Button } from "@mui/material";
import React from "react";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { FTPTheme } from "../../theme";
const FilterButton = ({ text, onClick }) => {
  return (
    <Button
      variant="outlined"
      startIcon={<FilterAltIcon />}
      size="large"
      sx={{
        color: FTPTheme.palette.text.primary,
        borderColor: FTPTheme.palette.text.primary,
      }}
      onClick={onClick}
    >
      {text}
    </Button>
  );
};

export default FilterButton;
